<template>
  <div class="coupon-popup" v-if="dialogVisible" v-dom-portal>
    <div class="popup-box-wrapper">
      <div class="popup-close" @click="hideDialog">
        <img src="@/assets/image/icons/icon-close-circle.png">
      </div>
      <div class="popup-box">
        <div class="header">
          <div class="title">{{ $t('title') }}</div>
          <div class="subtitle">{{ $t('subTitle') }}</div>
        </div>
        <div class="coupon-info">
          <div class="coupon-value">
            <div class="amount">
              <span class="unit">Rp</span>
              <span class="number">{{ couponInfo.rebate | formatMoney(true, true)}}</span>
            </div>
          </div>
          <div class="coupon-detail">
            <div class="name">{{ couponInfo.displayName[locale] }}</div>
            <div class="desc">
              {{ $t('noLimit') }}
            </div>
          </div>
        </div>
        <div class="btn-use">
          <md-button type="default" plain round @click="useCash">{{ $t('useNow') }}</md-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Popup, Button } from 'mand-mobile'
import dialogMixins from '@/mixins/dialog'

export default {
  i18n: {
    messages: {
      en: {
        title: 'Use Free Money',
        subTitle: 'Your bonus will be added to unused balance that can be invested or withdraw',
        useNow: 'USE NOW',
        investLimit: 'Invest at least ',
        noLimit: 'No minimum investment amount',
      },
      id: {
        title: 'Gunakan Uang Gratis',
        subTitle: 'Uang dimasukan ke sisa nominal Anda (untuk pendanaan atau ditarik)',
        useNow: 'Gunakan Sekarang',
        investLimit: 'Minimum pendanaan ',
        noLimit: 'Tidak ada batas minimum pendanaan',
      },
    },
  },
  components: {
    [Popup.name]: Popup,
    [Button.name]: Button,
  },
  props: {
    couponInfo: {
      type: Object,
      default: null,
    },
  },
  mixins: [dialogMixins],
  computed: {
    locale() {
      return this.$store.state.locale
    },
  },
  methods: {
    async useCash() {
      this.$emit('hideDialog')
      try {
        this.$toast.loading('loading...')
        await this.$http.post(`/transaction/coupon/use-cash?issuedId=${this.couponInfo.id}`, { issuedId: this.couponInfo.id })
        if (window.bridge && window.bridge.changeMainTab) {
          window.bridge.changeMainTab(3)
          return
        }
        this.$router.push({ name: 'UserOverview' })
      } catch (error) {
        console.log(error)
      } finally {
        this.$toast.hide()
      }
    },
  },
}
</script>

<style scoped lang="stylus">
.coupon-popup {
  z-index: 99999999999;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, .8);
  .popup-box-wrapper {
    position: absolute;
    width: 90%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .popup-close {
    text-align: right;
    img {
      width: 25px;
      height: 25px;
      margin-bottom: 10px;
    }
  }
  .popup-box {
    padding: 30px 20px 20px;
    border-radius: 6px;
    background-color: color-primary;
    color: #fff;
    text-align: center;
    max-height: 70vh;
    overflow-y: scroll;
  }
  .header {
    .title {
      font-size: 21px;
      font-weight: bold;
      line-height: 25px;
      margin-bottom: 8px;
    }
    .subtitle {
      font-size: 14px;
      line-height: 17px;
    }
  }
  .coupon-info {
    background-image: url('../../../assets/image/user/ticket/bg-coupon-available.png');
    background-size: 100% 100%;
    padding: 16px 6px;
    width: 100%;
    height: 86px;
    margin: 32px 0;
    display: flex;
    align-items: center;
    .coupon-value {
      width: 32%;
      color: color-primary;
      .rate {
        font-family: 'Reducto';
        font-size: 36px;
        line-height: 40px;
      }
      .amount {
        .unit {
          font-family: 'Reducto';
          font-size: 14px;
          margin-right: 2px;
        }
        .number {
          font-family: 'Reducto';
          font-size: 24px;
        }
      }
    }
    .coupon-detail {
      padding: 0 15px 10px;
      text-align: left;
      .name {
        color: #3F424E;
        font-size: 14px;
        line-height: 22px;
        margin-bottom: 4px;
      }
      .desc {
        color: #888;
        font-size: 10px;
        line-height: 12px;
      }
    }
  }
  .btn-use {
    width: 68vw;
    margin: 0 auto 20px;
  }
}
</style>
